
import classNames from 'classnames';
import { Fragment, memo } from 'react';
import './images/brands/brands.sprite.scss';
import './style.scss';

import { content, Product } from './text';

export default memo(() => {
    return (
        <div>
            <div className='banner boxsize-[100%_175px]'></div>
            <div className='bg'>
                {Object.entries(content).map(([name, list], index: number) => (
                    <Fragment key={index}>
                        <div className={classNames('ml-[15px]',[name])}></div>
                        <div className='grid grid-cols-2 gap-[5px] py-[20px] px-[15px]'>
                            {list.map(([bandName, link], index) => (
                                <div key={index} className='w-full py-[9px] rounded-[8px] bg-[#fff] grid grid-cols-[auto_1fr] grid-rows-[auto_auto] place-content-center leading-none gap-y-[2px]'
                                    onClick={()=>{
                                        if(link) window.open(`//${link}`)
                                    }}
                                >
                                    <div className=' row-span-2 pl-[30px] pr-[10px]'>
                                        <div className={classNames('brands shadow-[0_0_4px_0_#E2E2E2] rounded-[6px]', [Product[bandName as keyof typeof Product]])}></div>
                                    </div>
                                    <div className='text-[13px] font-bold content-end'>  {bandName} </div>
                                    <div className='text-[12px] items-end'>  {link} </div>
                                </div>
                            ))}
                        </div>
                    </Fragment>
                ))}
            </div >
        </div >
    );
})

